jQuery(document).ready(function($) {
  $("#enterprise_provider_max_subscriptions").on('wheel', function(e) {
    $(this).blur();
  })
})